import * as React from 'react';
import { t } from 'i18next';

import { SidebarHeader } from '../../SidebarHeader';
import { ProjectManagerHeader } from './ProjectManagerHeader';

export class ProjectManagerHeaderSmall extends ProjectManagerHeader {
    public render(): JSX.Element {
        return (
            <SidebarHeader text="">
                {this.props.editMode ?
                    <div className="sidebar-header-label editmode-label">{t('Edit projects')}</div> :
                    <div className="sidebar-header-label">{t('Projects')}</div>
                }
                <div
                    className={'project-edit-label' + ((this.props.projectsCount > 0) ? ' active' : '') + (this.props.editMode ? ' done-button' : '')}
                    onClick={this.toggleEdit}
                >
                    <span>{this.props.editMode ? t('Done') : ''}</span>
                </div>
                {this.editButton()}
            </SidebarHeader>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/projectmanager/ProjectManagerHeaderSmall.tsx